import { DependencyList, useEffect } from "react";

export const useResizeObserver = (callback: () => void, deps: DependencyList) => {
  
  useEffect(() => {
    const observer = new ResizeObserver(() => {
      callback()
    });
    observer.observe(document.body);

    return () => {
      observer.disconnect();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
}